<header>
  <div class="container">
    <div class="navbar-left">
      <div class="logo-wrapper">
        <a routerLink="/users" aria-label="Homepage">
          <img src="../../../assets/svg/eds-logo.svg" alt="Everyday Speech" class="header-logo" />
        </a>
      </div>
      <nav>
        <menu>
          <li>
            <a
              class="menu-item"
              routerLink="/users"
              routerLinkActive="active"
              #routeUsers="routerLinkActive"
              [attr.aria-current]="routeUsers.isActive ? 'page' : null"
              tabindex="0"
            >
              Users
            </a>
          </li>
          @if (isSpeechyAdmin) {
            <li>
              <a
                class="menu-item"
                routerLink="/organizations/management"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }"
                #routeOrgs="routerLinkActive"
                [attr.aria-current]="routeOrgs.isActive ? 'page' : null"
                tabindex="0"
              >
                Customer Organizations
              </a>
            </li>
            <li>
              <a
                class="menu-item"
                routerLink="/admin/users/all"
                routerLinkActive="active"
                #routeAllUsers="routerLinkActive"
                [attr.aria-current]="routeAllUsers.isActive ? 'page' : null"
                tabindex="0"
              >
                All Users
              </a>
            </li>
          }
        </menu>
      </nav>
    </div>

    <div class="navbar-right">
      <div class="secondary-menu-wrapper">
        <ul>
          @if (isSpeechyAdmin || isSupportRole) {
            <li>
              <a target="_blank" tabindex="0" [href]="adminPortalV1Url">Open Admin Portal 1</a>
            </li>
          } @else {
            <li>
              <a
                target="_blank"
                tabindex="0"
                href="https://meetings.hubspot.com/mattia6/admin-portal-renewal-quote?uuid=a32bf760-1579-4169-beee-68b59e2aa42c"
              >
                <icon icon="calendar" variant="regular" scale="1.25"></icon>
                Contact Your Rep
              </a>
            </li>
          }
        </ul>
        <dropdown-menu></dropdown-menu>
      </div>
    </div>
  </div>
</header>
